import type { Page } from './api';

export async function loadAllPages<T>(load:(limit:number,offset:number)=>Promise<Page<T>>):Promise<T[]> {
  const items:T[]=[];
  for(let offset=0;;) {
    const page=await load(100,offset);
    items.push(...page.items);
    if(!page.items.length||page.items.length<(page.limit||100))return items;
    offset+=page.items.length;
  }
}
